<template>
    <div class="siteNavWrap">
        <div class="siteNavList">
            <template v-for="(item, index) in siteNavList">
                <!-- 超链接 -->
                <router-link v-if="index !== siteNavList.length - 1"
                             :key="index"
                             :to="item.link ? item.link : '/'"
                             @click.native="item.bigData">
                    {{item.name}}</router-link>
                <!-- 最后一个刷新当前页面 -->
                <a v-else
                   :key="index"
                   href="javascript:void(0)">{{item.name}}</a>
                <span v-if="index !== siteNavList.length - 1"
                      :key="index + '1'"
                      class="gt">&gt;</span>
            </template>
        </div>
        <a v-if="!isIntl"
           :href="isImport ? importCustomerServiceQQ : customerServiceQQ"
           target="_blank"
           class="customerServiceQQ"
           @click="$bigData('service','小喵在线','1')">
            <i class="iconfont icon-kefu"></i>
            <span>{{$t('message.customerService')}}</span>
        </a>
        <div v-else
             class="customerServiceQQ"   
             style="color: #666; cursor: auto;"                         
             @click="$bigData('customerServiceQQ', '小喵在线', '1')"> 
            <template v-if="importEmailCustomerServiceEmail">
                <span>{{$t('message.contactcustomer')}}</span>
                <a :href="'mailto:' + importEmailCustomerServiceEmail" style="margin-left: 10px; color: #009fe8;">
                    <i class="el-icon-message"></i>
                    <span style="margin-left: 10px;">{{importEmailCustomerServiceEmail}}</span>
                </a>
            </template>                               
            
        
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SiteNav',// 站点面包屑导航
        props: {
            // 站点面包屑列表
            siteNavList: {
                type: Array,
                default: () => {
                    return [
                        {
                            name: ' - ',
                            link: window.location.href,
                            bigData: ''
                        },
                        {
                            name: ' - ',
                            link: '',
                            bigData: ''
                        }
                    ];
                }
            },
        },
        data() {
            return {
                isIntl: location.origin.includes('https://intl.3j-mall.com')
            };
        },
        computed: {
            overseasType() {
                return this.$store.state.Login.loginData.overseasType;
            },
            // 海外用户标志
            importEmailCustomerServiceEmail() {
                return this.$store.state.importEmailCustomerServiceEmail;
            },
            // 客服QQ
            customerServiceQQ() {
                return this.$pcOrMobileQQ(this.$store.state.customerServiceQQ);
            },
            // 进口客服qq
            importCustomerServiceQQ() {
                return this.$pcOrMobileQQ(this.$store.state.importCustomerServiceQQ);
            },
            isImport() {
                return this.siteNavList.some(v => v.name === '进口管理');
            }
        }
    };
</script>

<style lang="scss" scoped>
    .siteNavWrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 15px 0 6px;

        .siteNavList {
            a,
            span {
                font-size: 14px;
                color: #888;
                user-select: none;
            }

            a:hover {
                color: #009fe8;
            }

            .gt {
                margin: 0 5px;
            }
        }

        .customerServiceQQ {
            color: #009fe8;

            .iconfont {
                margin-right: 3px;
                font-size: 30px;
                vertical-align: middle;
            }
        }
    }
</style>
